import { render, staticRenderFns } from "./buttonNext.vue?vue&type=template&id=0d60bf3d&"
import script from "./buttonNext.vue?vue&type=script&lang=js&"
export * from "./buttonNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports